export const GET_ALL_ORGANIZATIONS = 'GET_ALL_ORGANIZATIONS';
export const SET_ORGS_COUNT = 'SET_ORGS_COUNT';
export const GET_ORGANIZATION = 'GET_ORGANIZATION';